/**
 * Default name of the cookie storing customer group
 */
export const CUSTOMER_GROUP_COOKIE = 'customer_group';
